import React from 'react';
import Tax from './Tax';
 
export default (props) => <Tax {...props}/>;
